module.exports = __webpack_public_path__ + "static/schlumberger-80d755c20bf7881471f88c661fe40af9.png";